export default __webpack_public_path__ + "static/media/logout.c063a4b6.png";